module.exports = __webpack_public_path__ + "static/img/create-single@2x.34f67440.svg";